export enum StorageKeysEnum {
  RememberLastPage = 'REMEMBER_LAST_PAGE',
  LastPage = 'LAST_PAGE',
  Language = 'LANGUAGE',
  FacebookAccessToken = 'FACEBOOK_ACCESS_TOKEN',
  EulaAccepted = 'EULA_ACCEPTED',
}
